import { FC, createContext, ReactNode, useContext } from "react";
import { JourneyType} from "src/Modules/Flights/constants/JourneyListing";
import { SearchFormInputs } from "src/Modules/Flights/constants";
import { FlightDetailsHookReturnType } from "src/store/slices/flights/Flights";

type JourneyStaticContextType = {
  journeySearchData: JourneyType;
  searchObject: SearchFormInputs; 
  journeyDetails:FlightDetailsHookReturnType;
};

const JourneyStaticDetailsContext = createContext<JourneyStaticContextType | null>(null);

const JourneyStaticDetailsProvider: FC<{ children: ReactNode; value: JourneyStaticContextType }> = ({ children, value }) => {
  return <JourneyStaticDetailsContext.Provider value={value}>{children}</JourneyStaticDetailsContext.Provider>;
};

const useJourneyStaticDetails = () => {
  const context = useContext(JourneyStaticDetailsContext);
  if (!context) throw new Error("Illegal Usage of context");
  return context;
};

export { useJourneyStaticDetails, JourneyStaticDetailsProvider };
export {JourneyStaticDetailsContext};
export type{JourneyStaticContextType};
